import { useState, useEffect } from "react";
import { Button, Form, Input } from "antd";
import { useLocation, useNavigate } from "react-router";

import { GetUrlParams, ObjectNumbersToEnglish } from "scripts/helpers";
import { Patterns } from "scripts/settings";
import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import InputCode from "components/input-code";

const Component = () => {
	const initialState = { countdown: 0, counter: 0 };
	const [state, setState] = useState(initialState);
	const { countdown, counter, submitting } = state;
	const [form] = Form.useForm();
	const { search } = useLocation();
	const navigate = useNavigate();
	const { mobile } = GetUrlParams(search);

	const handleCode = () => {
		if (!submitting) {
			setState((prevState) => ({ ...prevState, submitting: true }));

			API.auth
				.getOtp({ phone: mobile })
				.then(({ otpExpirationSeconds }) => {
					setState((prevState) => ({
						...prevState,
						submitting: false,
						countdown: otpExpirationSeconds,
						counter: otpExpirationSeconds,
					}));
				})
				.catch(() => {
					setState((prevState) => ({
						...prevState,
						submitting: false,
					}));
				});
		}
	};

	const handleCountdown = () => {
		const timeout = setTimeout(() => {
			setState((prevState) => ({
				...prevState,
				countdown: prevState.countdown - 1,
			}));
		}, 1000);

		if (countdown < 1) clearTimeout(timeout);
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				API.auth
					.verify(values)
					.then(() => {
						navigate({
							pathname: "/auth/register",
							search: `?mobile=${values.phone}`,
						});
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		if (Patterns.mobile.test(mobile)) {
			form.setFieldValue("phone", mobile);

			handleCode();
		} else {
			navigate("/auth/status", { replace: true });
		}
	};

	useEffect(handleCountdown, [countdown]);
	useEffect(componentDidMount, []);

	return (
		<>
			<h1 className="heading">{`${Resources.confirm} ${Resources.number} ${Resources.phone} ${Resources.along}`}</h1>
			<span className="text">{Resources.verifyText}</span>
			<Form form={form} layout="vertical" requiredMark={false}>
				<Form.Item name="phone" label={Resources.mobile} rules={Rules.mobile}>
					<Input
						className="input-ltr"
						readOnly
						type="tel"
						size="large"
						placeholder={Resources.mobile}
						suffix={<Icons.Calling />}
					/>
				</Form.Item>
				<Form.Item name="code" label={Resources.code} rules={Rules.required}>
					<InputCode
						countdown={countdown}
						percent={100 - Math.round((countdown * 100) / counter)}
						submitting={submitting}
						onResend={handleCode}
					/>
				</Form.Item>
			</Form>
			<div className="actions">
				<Button
					className="btn-default"
					size="large"
					loading={submitting}
					onClick={() => navigate("/auth/status", { replace: true })}
				>
					{`${Resources.edit} ${Resources.mobile}`}
				</Button>
				<Button
					type="primary"
					size="large"
					loading={submitting}
					onClick={handleSubmit}
				>
					{Resources.enter}
				</Button>
			</div>
		</>
	);
};

export default Component;
